export const getSurplusBeforeTaxYear2 = (value) => {
  return {
    type: "GET_SURPLUS_BEFORE_TAX_YEAR_2",
    payload: value,
  };
};

export const getTemplatePayrollTaxYear2 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_TAX_YEAR_2",
    payload: value,
  };
};
export const getTemplatePayrollPercentYear2 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getFixedEarnedIncomeYear2 = (value) => {
  return {
    type: "GET_FIXED_EARNED_INCOME_YEAR_2",
    payload: value,
  };
};

export const getStandardTaxReliefYear2 = (value) => {
  return {
    type: "GET_STANDARD_TAX_RELIEF_YEAR_2",
    payload: value,
  };
};
export const getTaxableIncomeYear2 = (value) => {
  return {
    type: "GET_TAXABLE_INCOME_YEAR_2",
    payload: value,
  };
};
export const getLocalTaxesYear2 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_YEAR_2",
    payload: value,
  };
};
export const getLocalTaxesPercentYear2 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getStateTaxYear2 = (value) => {
  return {
    type: "GET_STATE_TAX_YEAR_2",
    payload: value,
  };
};
export const getStateTaxCutOfValueYear2 = (value) => {
  return {
    type: "GET_STATE_TAX_CUT_OF_VALUE_YEAR_2",
    payload: value,
  };
};
export const getStateTaxPercentYear2 = (value) => {
  return {
    type: "GET_STATE_TAX_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getPayrollTaxYear2 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_YEAR_2",
    payload: value,
  };
};
export const getPayrollTaxPercentYear2 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getGeneralPensionYear2 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_YEAR_2",
    payload: value,
  };
};
export const getGeneralPensionCutOffValueYear2 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_CUT_OFF_VALUE_YEAR_2",
    payload: value,
  };
};
export const getGeneralPensionPercentYear2 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getFuneralFeesYear2 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_YEAR_2",
    payload: value,
  };
};
export const getFuneralFeesPercentYear2 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getReductionOfGeneralPensionYear2 = (value) => {
  return {
    type: "GET_REDUCTION_OF_GENERAL_PENSION_YEAR_2",
    payload: value,
  };
};
export const getEarnedIncomeTaxYear2 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_YEAR_2",
    payload: value,
  };
};
export const getEarnedIncomeTaxCutOffValueYear2 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE_YEAR_2",
    payload: value,
  };
};
export const getEarnedIncomeTaxPercentYear2 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getNetProfitPerYearYear2 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_YEAR_YEAR_2",
    payload: value,
  };
};
export const getNetProfitPerMonthYear2 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_MONTH_YEAR_2",
    payload: value,
  };
};
export const getGeneralPayrollTaxYear2 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_YEAR_2",
    payload: value,
  };
};
export const getGeneralPayrollTaxPercentYear2 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_PERCENT_YEAR_2",
    payload: value,
  };
};
export const getGrossAnnualSalaryYear2 = (value) => {
  return {
    type: "GET_GROSS_ANNUAL_SALARY_YEAR_2",
    payload: value,
  };
};
export const getNonTaxableIncomeLimitYear2 = (value) => {
  return {
    type: "GET_NON_TAXABLE_INCOME_LIMIT_YEAR_2",
    payload: value,
  };
};
